var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsAsc = function SvgArrowsAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.966 4.69 13.548.271l-4.42 4.42 1.18 1.177 2.406-2.406V19.6h1.667V3.461l2.407 2.407zM5.79 13.068V6.75H4.125v6.318l-2.407-2.406L.54 11.84l4.419 4.419 4.418-4.419-1.178-1.178z"
  })));
};
export default SvgArrowsAsc;